var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.60295 14.8188H4.29691L4.68701 14.2509C4.87395 13.9788 4.96124 13.7219 4.96124 13.4693C4.96124 13.2112 4.87003 12.9443 4.6742 12.6581L3.82001 11.4096H15.8276V0.841226C15.8276 0.602996 15.5114 0.438225 15.2153 0.522183L11.7745 1.49783L8.28841 0.52169C8.18502 0.492739 8.07115 0.493205 7.96818 0.523001L4.57174 1.50582L1.04366 0.521548C0.747944 0.439046 0.433594 0.603767 0.433594 0.841226V12.4324C0.433594 13.7504 1.85256 14.8188 3.60295 14.8188ZM4.50865 4.5918H8.13077C8.38083 4.5918 8.58354 4.74443 8.58354 4.93271C8.58354 5.121 8.38083 5.27363 8.13077 5.27363H4.50865C4.2586 5.27363 4.05589 5.121 4.05589 4.93271C4.05589 4.74443 4.2586 4.5918 4.50865 4.5918ZM11.7527 7.31832H4.50848C4.25842 7.31832 4.05571 7.47096 4.05571 7.65924C4.05571 7.84752 4.25842 8.00016 4.50848 8.00016H11.7527C12.0028 8.00016 12.2055 7.84752 12.2055 7.65924C12.2055 7.47096 12.0028 7.31832 11.7527 7.31832ZM19.0156 13.7941C19.0156 12.8637 18.0256 12.1074 16.7955 12.0898H4.9613C5.70428 12.6497 6.10106 13.218 6.10253 13.8062C6.104 14.3943 5.71025 14.9544 4.97024 15.4987H16.7518C18.0021 15.4987 19.0156 14.7355 19.0156 13.7941Z",
    fill: "#7A869A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadReceiptIcon);
export default __webpack_public_path__ + "static/media/download-receipt-icon.f7ec33a15149747640f7dd4470f018d1.svg";
export { ForwardRef as ReactComponent };